import { createAction, props } from '@ngrx/store';

import { DashboardFilter } from '@dashboards/models/dashboard-filter';

export const setDashboardFilter = createAction('[DashboardFilter] Load DashboardFilters', props<DashboardFilter>());
